import React from "react";
import "./Guida.css";

export default function Guida() {
  const guideSections = [
    {
      title: "Inserimento Spesa",
      steps: [
        " 'Spese' dal menu laterale.",
        "Clicca sul pulsante per aggiungere una nuova spesa (solitamente un'icona '+' o 'Nuova Spesa').",
        "Compila tutti i campi richiesti: Data, Importo, Categoria e Descrizione.",
        "Allega la foto o il file dello scontrino/fattura tramite l'apposito pulsante di upload.",
        "Clicca su 'Salva' per registrare la spesa nel sistema.",
      ],
    },
    {
      title: "Compilazione Foglio Presenza",
      steps: [
        "Vai alla voce 'Foglio Presenza' nel menu.",
        "Seleziona il mese di riferimento se necessario.",
        "Per ogni giorno lavorativo, inserisci le ore prestate, il cantiere e il mezzo utilizzato.",
        "Se previsto, inserisci eventuali note o dettagli aggiuntivi.",
        "Nel caso in cui sia stata correttamente eseguita la timbratura le ore lavorate saranno precompilate.",
        "Analogamente, cantiere e mezzo seguiranno quanto previsto dalla programmazione effettuata dal Responsabile Tecnico.",
        "Assicurati che tutti i dati corrispondano a quanto effettivamente successo durante la giornata lavorativa prima di confermare.",
      ],
    },
    {
      title: "Download Documenti",
      steps: [
        "Naviga nella sezione 'Documenti' o 'Anagrafica'.",
        "Troverai i documenti disponibili. Busete paga, CUD e altri documenti",
        "Clicca sull'icona di download, nel caso dei documenti periodici, seleziona prima il periodo di competenza.",
        "Il file verrà salvato sul tuo dispositivo.",
      ],
    },
    {
      title: "Aggiornamento Anagrafica",
      steps: [
        "Accedi al tuo 'Profilo' o alla sezione 'Anagrafica' dal menu.",
        "Visualizza i tuoi dati attuali.",
        "Clicca sul pulsante di modifica (icona matita o 'Modifica') per abilitare i campi modificabili.",
        "Aggiorna le informazioni necessarie (es. Indirizzo, IBAN, Numero di Telefono).",
        "Conferma le modifiche cliccando su 'Salva'.",
      ],
    },
  ];

  return (
    <div className="guida-container">
      <h1 className="guida-title">Guida all'Uso dell'App</h1>
      <div className="guida-grid">
        {guideSections.map((section, index) => (
          <div key={index} className="guida-card">
            <h2 className="guida-card-title">{section.title}</h2>
            <ul className="guida-steps">
              {section.steps.map((step, stepIndex) => (
                <li key={stepIndex} className="guida-step">
                  <span className="guida-step-number">{stepIndex + 1}</span>
                  <span className="guida-step-text">{step}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
}
